import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import(/* webpackChunkName: "group-foo" */ './views/Home.vue')
const About = () => import(/* webpackChunkName: "group-foo" */ './views/About.vue')
const Work = () => import(/* webpackChunkName: "group-foo" */ './views/Work.vue')
const Clients = () => import(/* webpackChunkName: "group-foo" */ './views/Clients.vue')
const Contact = () => import(/* webpackChunkName: "group-foo" */ './views/Contact.vue')

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About

    },
    {
      path: '/work/:p/:i',
      name: 'work',
      component: Work

    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients

    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact

    },
  ]
});
